import React, { useState } from 'react';
import styled, {css} from 'styled-components';
import theme from "../../../UI/theme";
import { FormAnswer } from "../Form";
import ProgressDots from "../ProgressDots";
import Button from "../../UiComponents/Button"; 
import { ButtonRowContainer } from '../../panel/ModalStyles';
import TextArea from '../../UiComponents/text/TextArea';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;

    p {
        font-size: 1.2rem;
        color: ${theme.colors.textGray};
        text-align: center;
        font-weight: 600;
        margin-bottom: 0px;
    }
`

const OptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 10px;
`

const Pill = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    background-color: ${theme.colors.darkSpace90};
    color: ${theme.colors.darkSpace10};
    border-radius: 18px;
    font-size: ${theme.fontSize.small};
    border: 1px solid ${theme.colors.greenEnergy};
    margin: 1px 2px;
    width: fit-content;

    &:hover {
        cursor: pointer;
        color: ${theme.colors.greenEnergy};
        ${({ $selected }) =>
            $selected &&
            css`
                color: black;
            `
        }

    }

    ${({ $selected}) =>
        $selected &&
        css`
            background-color: ${theme.colors.greenEnergy};
            color: black;
            border-color: ${theme.colors.greenEnergy};
        `
    }
`;


const PillMultiSelect = ({ form, questionDetails, nextQuestion, nextText, closable=true, close=() => {}, totalQuestions=null, currentQuestionNumber=null, isLastQuestion=false }) => {
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [otherSpesifficationText, setOtherSpesifficationText] = useState('');
    
    const toggleOption = (option) => {
        if (selectedOptions.includes(option)) {
            setSelectedOptions(selectedOptions.filter(o => o !== option));
        } else {
            setSelectedOptions([...selectedOptions, option]);
        }
    }

    const submitAnswer = async () => {
        if (selectedOptions.length === 0) return nextQuestion();
        const answer = new FormAnswer(form, questionDetails.questionId, questionDetails.questionNumber, questionDetails.questionText, questionDetails.answerValueType);
        answer.setAnswerValue(JSON.stringify(selectedOptions));
        await answer.save();
        nextQuestion();
    }

    const onCloseHandler = async () => {
        if (closable) {
            await submitAnswer();
            close();
        }
    }

    return (
        <Container>
            {(totalQuestions && currentQuestionNumber) && <ProgressDots total={totalQuestions} current={currentQuestionNumber} />}
            <h2>{questionDetails.questionText}</h2>
            {questionDetails.questionSubtext && <p>{questionDetails.questionSubtext}</p>}
            <OptionsContainer>
                {questionDetails.pillOptions.map(option => (
                    <Pill key={option} $selected={selectedOptions.includes(option)} onClick={() => toggleOption(option)}>
                        {option}
                    </Pill>
                ))}
                {selectedOptions.find(o => o.startsWith('Other')) && (
                    
                    <TextArea placeholder='Please specify' rows={2} value={otherSpesifficationText} onChange={(e) => {
                        const otherOption = `Other: ${e.target.value}`;
                        setOtherSpesifficationText(e.target.value);
                        setSelectedOptions([...selectedOptions.filter(o => !o.startsWith('Other:') && o !== 'Other'), otherOption]);
                    }} />
                )}
            </OptionsContainer>
            <ButtonRowContainer>
                <Button disabled={selectedOptions.length === 0 && !isLastQuestion}  primary onClick={submitAnswer} style={{marginTop: '20px'}}>{nextText || (isLastQuestion ? 'Submit' : 'Next')}</Button>
                {(closable && !isLastQuestion)&& <Button secondary onClick={onCloseHandler} style={{marginTop: '20px'}}>Close</Button>}
            </ButtonRowContainer>
        </Container>
    )
}

export default PillMultiSelect;